// services/mappers/campus.js
import replaceDomain from "../../utils/replaceDomain";
import { CheckValue } from "../service";
import { setDroneNest } from "./droneNest";
import { setFloors } from "./floor";

export const setCampusData = (el = {}) => {
  const floors = CheckValue(el.floors) ? el.floors.map(setFloors) : [];

  let availableDrone = [];
  let availableDoors = [];
  let unavailableDrone = [];

  const drone_nests = CheckValue(el.drone_nests)
    ? el.drone_nests.map((drone_nest) => {
        const temp = setDroneNest(drone_nest);
        const matchingFloor = floors.find(
          (floor) => floor.id === drone_nest.floor_id,
        );
        if (matchingFloor) temp.floor = matchingFloor;

        temp.drones.forEach((drone) => {
          const entry = { ...drone, drone_nest: { ...temp } };
          (drone.status === "AVAILABLE"
            ? availableDrone
            : unavailableDrone
          ).push(entry);
        });
        if (temp?.doors && !!temp.doors?.id) {
          availableDoors.push({ ...temp });
        }

        return temp;
      })
    : [];

  return {
    createdAt: el.CreatedAt || null,
    updatedAt: el.UpdatedAt || null,
    deletedAt: el.DeletedAt || null,
    id: el.id || el.ID || null,
    campus_number: el.campus_number || 0,
    site_ip: el.site_ip || "",
    name: el.name || null,
    address: el.address || null,
    city: el.city || null,
    state: el.state || null,
    zip_code: el.zip_code || null,
    invite_code: el.invite_code || null,
    created_by_id: el.created_by_id || null,
    latitude: el.latitude || null,
    longitude: el.longitude || null,
    icon_url: replaceDomain(el.icon_url),
    active_incident: el.active_incident || false,
    available_doors: el?.available_doors ?? availableDoors.length ?? 0,
    available_drones: el.available_drones || 0,
    unavailable_drones: el.unavailable_drones || 0,
    drone_nests,
    floors,
    availableDrone,
    unavailableDrone,
    availableDoors,
  };
};
